import type { ReactNode } from "react";

/**
 * 화면 제목 블록 — 원본 `app.css` 의 `.page-head`.
 *
 * 모바일에서 세로로 쌓고 액션을 전폭으로 늘립니다(원본의 `max-width: 600px` 블록). 버튼은
 * `inline-flex` 라 컨테이너만 넓혀서는 늘어나지 않으므로 자식에 `flex-1` 을 줍니다.
 */
export function PageHead({
  title,
  sub,
  actions,
}: {
  title: string;
  sub?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="mb-[24px] flex flex-col items-start gap-[16px] sm:flex-row sm:items-end">
      <div>
        <h1 className="m-0 text-[22px] font-bold tracking-[-0.025em] sm:text-[26px]">{title}</h1>
        {sub ? <p className="mt-[6px] text-[14px] text-grey-500">{sub}</p> : null}
      </div>
      {actions ? (
        <div className="flex w-full gap-[8px] sm:ml-auto sm:w-auto [&>*]:flex-1 sm:[&>*]:flex-none">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
